import { render, staticRenderFns } from "./TemplateFilter.vue?vue&type=template&id=1aa5162b"
import script from "./TemplateFilter.vue?vue&type=script&lang=ts"
export * from "./TemplateFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports